import { render, staticRenderFns } from "./DashboardTrendItem.vue?vue&type=template&id=734fe86f"
import script from "./DashboardTrendItem.vue?vue&type=script&lang=js"
export * from "./DashboardTrendItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports